import { Switch } from "react-router-dom";
import TruWebForm from "./components/TruWebForm";

function App() {
    return (
        <div className="App">
            <Switch>
                <TruWebForm />
            </Switch>
        </div>
    );
}

export default App;